/* src/components/GardeEcran.jsx — LE BANDEAU DE SECOURS (décision Dimitri
   2026-08-28 : « un écran blanc sans navigation, c'est le pire cas »).

   Garde d'erreur posée SOUS la navigation, autour du contenu de l'onglet :
   quand un écran casse au rendu, le menu reste vivant et l'écran est
   remplacé par ce bandeau — qui avoue l'erreur et propose de réessayer.
   Montée avec `key={tab}` dans App : changer d'onglet remet la garde à
   zéro, un écran cassé n'emprisonne jamais les autres.

   Le filet global de index.js (Sentry.ErrorBoundary plein écran) reste le
   dernier recours — il ne se déclenche plus que si la navigation elle-même
   casse. */
import React from 'react'
import { captureGarde } from '../lib/sentry'

export default class GardeEcran extends React.Component {
  constructor(props) {
    super(props)
    this.state = { erreur: null }
  }

  static getDerivedStateFromError(erreur) {
    return { erreur }
  }

  componentDidCatch(erreur, info) {
    console.error('[garde-ecran] écran cassé :', erreur, info?.componentStack)
    try {
      captureGarde('garde-ecran', erreur?.message || String(erreur), {
        tab: this.props.tab,
        stack: info?.componentStack?.slice(0, 2000),
      })
    } catch { /* la garde ne doit jamais casser à son tour */ }
  }

  render() {
    if (!this.state.erreur) return this.props.children
    return (
      <div className="fbz-tab-content" data-testid="bandeau-secours">
        <div
          style={{
            margin: '18px auto',
            maxWidth: 560,
            background: '#fff',
            border: '1px solid #f3d3d3',
            borderLeft: '4px solid #E24B4A',
            borderRadius: 12,
            padding: '18px 20px',
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 15, color: '#A32D2D' }}>
            Cet écran a rencontré une erreur.
          </div>
          <p style={{ fontSize: 13, color: '#5a6470', margin: '8px 0 14px', lineHeight: 1.5 }}>
            Le reste de l'application fonctionne — la navigation ci-dessus
            reste utilisable. Vous pouvez réessayer cet écran, ou changer
            d'écran par le menu.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => this.setState({ erreur: null })}
              style={{
                padding: '9px 16px',
                background: '#3d5166',
                color: '#fff',
                border: 'none',
                borderRadius: 9,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Réessayer cet écran
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '9px 16px',
                background: '#fff',
                color: '#3d5166',
                border: '1px solid #cdd7e3',
                borderRadius: 9,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Recharger la page
            </button>
          </div>
        </div>
      </div>
    )
  }
}
